import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import PageHead from "../components/Common/PageHead";
import { addCrm } from "../services/firestoreService";

const ConsultationSignUp = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    agencyName: "",
    website: "",
    plan: "Not selected yet",
    topic: "General consultation",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    await addCrm(formData);

    alert(
      "Thanks for booking a consultation. We will reach out to you shortly."
    );

    setFormData({
      name: "",
      email: "",
      agencyName: "",
      website: "",
      plan: "Not selected yet",
      topic: "General consultation",
      message: "",
    });
  };

  return (
    <>
      <Helmet>
        <title>Book a Consultation | AI Agency Directory</title>
        <meta
          name="description"
          content="Book a 1 to 1 consultation to get help setting up your AI agency profile, choosing a plan, or integrating CRM tools with AI Agency Directory."
        />
      </Helmet>

      <PageHead
        pagename="Book Your Consultation"
        subheading="Need help with sign up, plan selection, or CRM integration. Tell us a bit about your agency and we will reach out."
      />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <div className="bg-white shadow-lg rounded-2xl border border-gray-100 p-6 sm:p-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-secondary mb-4">
            Consultation Sign Up
          </h2>
          <p className="text-gray-600 mb-6 text-sm sm:text-base">
            This is a dedicated form for agencies that want guided onboarding or
            premium features such as CRM integration and advanced lead handling.
          </p>

          <form className="space-y-5" onSubmit={handleSubmit}>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Full name
              </label>
              <input
                type="text"
                name="name"
                className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Jane Doe"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                name="email"
                className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="you@example.com"
              />
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Agency name
                </label>
                <input
                  type="text"
                  name="agencyName"
                  className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  value={formData.agencyName}
                  onChange={handleChange}
                  placeholder="Your AI agency name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Website
                </label>
                <input
                  type="url"
                  name="website"
                  className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  value={formData.website}
                  onChange={handleChange}
                  placeholder="https://youragency.com"
                />
              </div>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Current plan
                </label>
                <select
                  name="plan"
                  className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  value={formData.plan}
                  onChange={handleChange}
                >
                  <option value="Not selected yet">Not selected yet</option>
                  <option value="Basic">Basic</option>
                  <option value="Premium">Premium</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Main topic
                </label>
                <select
                  name="topic"
                  className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                  value={formData.topic}
                  onChange={handleChange}
                >
                  <option value="General consultation">
                    General consultation
                  </option>
                  <option value="Help with sign up">Help with sign up</option>
                  <option value="Profile and positioning">
                    Profile and positioning
                  </option>
                  <option value="CRM integration">
                    CRM integration and lead routing
                  </option>
                </select>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                What do you want help with.
              </label>
              <textarea
                name="message"
                rows={4}
                className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                value={formData.message}
                onChange={handleChange}
                placeholder="Describe your use case, current tools, and any goals you have for CRM and lead management."
              />
            </div>

            <div className="pt-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
              <p className="text-xs sm:text-sm text-gray-500">
                Premium agencies receive priority support and CRM integration
                guidance.
              </p>
              <button
                type="submit"
                className="inline-flex justify-center items-center bg-primary text-white rounded-full px-7 py-2.5 text-sm sm:text-base font-semibold hover:bg-blue-600 transition"
              >
                Submit Request
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ConsultationSignUp;
